import axios from 'axios';

export default {
  index(succ) {
    axios.get('/users/delivery_addresses').then((response) => {
      succ(response.data);
    });
  },
  create(address) {
    return axios.post('/users/delivery_addresses', address);
  },
  update(address) {
    return axios.patch(`/users/delivery_addresses/${address.id}`, address);
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/delivery_addresses.js